import { FiatCurrency } from '__generated__/globalTypes';
import { useCurrentUserCurrencies } from 'hooks/useCurrentUserCurrencies';

import eurImg from './assets/eur.png';
import gpbImg from './assets/gpb.png';
import usdImg from './assets/usd.png';

const currencyIcons = {
  [FiatCurrency.USD]: usdImg,
  [FiatCurrency.GBP]: gpbImg,
  [FiatCurrency.EUR]: eurImg,
};

export const FiatWalletIcon = () => {
  const { fiatCurrency } = useCurrentUserCurrencies();
  return <img src={currencyIcons[fiatCurrency]} alt={fiatCurrency} />;
};
